var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/core-js/library/modules/_html.js
// module id = 965
// module chunks = 48 49 50